export default __webpack_public_path__ + "static/media/17.aa9bb58b.png";